import { VerticalStyle } from './VerticalStyle'
import { withVerticalStyle } from './withVerticalStyle'

const ConnectedVerticalStyle = withVerticalStyle(VerticalStyle)

export { ConnectedVerticalStyle as VerticalStyle }
